import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

interface CreditPaymentFormProps {
  totalAmount: number;
  isCredit: boolean;
  onCreditChange: (checked: boolean) => void;
  partialPayment: string;
  onPartialPaymentChange: (value: string) => void;
  customerName: string;
  onCustomerNameChange: (value: string) => void;
  customerContact: string;
  onCustomerContactChange: (value: string) => void;
  paymentDate: string;
  onPaymentDateChange: (value: string) => void;
  customerSignature: string;
  onCustomerSignatureChange: (value: string) => void;
  customerAddress?: string;
  onCustomerAddressChange?: (value: string) => void;
}

export const CreditPaymentForm = ({
  totalAmount,
  isCredit,
  onCreditChange,
  partialPayment,
  onPartialPaymentChange,
  customerName,
  onCustomerNameChange,
  customerContact,
  onCustomerContactChange,
  paymentDate,
  onPaymentDateChange,
  customerSignature,
  onCustomerSignatureChange,
  customerAddress = "",
  onCustomerAddressChange = () => {},
}: CreditPaymentFormProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Switch
          id="credit-payment"
          checked={isCredit}
          onCheckedChange={onCreditChange}
        />
        <Label htmlFor="credit-payment">Paiement à crédit</Label>
      </div>

      {isCredit && (
        <div className="space-y-4">
          <div>
            <Label>Nom du client</Label>
            <Input
              value={customerName}
              onChange={(e) => onCustomerNameChange(e.target.value)}
              placeholder="Nom complet"
            />
          </div>

          <div>
            <Label>Contact du client</Label>
            <Input
              value={customerContact}
              onChange={(e) => onCustomerContactChange(e.target.value)}
              placeholder="Numéro de téléphone"
            />
          </div>

          <div>
            <Label>Adresse du client</Label>
            <Textarea
              value={customerAddress}
              onChange={(e) => onCustomerAddressChange(e.target.value)}
              placeholder="Adresse complète"
              className="resize-none h-20"
            />
          </div>

          <div>
            <Label>Montant payé maintenant</Label>
            <Input
              type="number"
              value={partialPayment}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (parseFloat(value) >= 0 && parseFloat(value) <= totalAmount)) {
                  onPartialPaymentChange(value);
                }
              }}
              min="0"
              max={totalAmount}
              placeholder="0"
            />
            {partialPayment && (
              <p className="text-sm text-muted-foreground mt-1">
                Reste à payer: {(totalAmount - parseFloat(partialPayment || "0")).toLocaleString()} FCFA
              </p>
            )}
          </div>

          <div>
            <Label>Date de paiement prévue</Label>
            <Input
              type="date"
              value={paymentDate}
              onChange={(e) => onPaymentDateChange(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div>
            <Label>Signature du client</Label>
            <Textarea
              value={customerSignature}
              onChange={(e) => onCustomerSignatureChange(e.target.value)}
              placeholder="Description de la signature"
            />
          </div>
        </div>
      )}
    </div>
  );
};